export default __webpack_public_path__ + "static/0062-03fd3e7b0f2193c85ea365f56ec4272b.png";